import { SpecialFreightIdView } from '../../../models';

export class ShipmentSpecialFreightItemSetIdentifier {
  public static readonly type = '[ShipmentSpecialFreightItem] Set Identifier';
  constructor(public payload: SpecialFreightIdView) {}
}

export class ShipmentSpecialFreightItemNotificationListCountLoad {
  public static readonly type = '[ShipmentSpecialFreightItem] Notification List Count Load';
  constructor(public payload: SpecialFreightIdView) {}
}

export class ShipmentSpecialFreightItemSetInitial {
  public static readonly type = '[ShipmentSpecialFreightItem] Set Initial State';
}
